export const REGEX_WITH_SYMBOLS = /[.,:-]/g;
export const REGEX_WITH_SPACING = /\s/g;

export const checkIsStringContainsSymbols = (str: string) => REGEX_WITH_SYMBOLS.test(str);
export const checkIsStringContainsSpacing = (str: string) => REGEX_WITH_SPACING.test(str);
